import { Checkbox, FormGroup, Spacer, TextInput } from '@ksyos/design-system';
import { useState } from 'react';
import { FormValidationMessage } from '../elements/FormValidationMessage';
import { TextInputWithLabel } from './TextInputField';

interface ICheckboxGroupProps {
    checkboxOptions: {
        checked: boolean;
        label: string;
        onChange: (value: boolean) => void | Promise<void>;
    }[];
    error?: string;
    hasErrors?: boolean;
    isRequired?: boolean;
    label: string;
    tooltipText?: string;
}

/**
 * @deprecated CS-25100 use CheckboxGroupFormGroup instead. Remove if no longer used.
 */
export function CheckboxGroupOld(props: ICheckboxGroupProps) {
    return (
        <FormGroup
            hasErrors={props.hasErrors}
            isRequired={props.isRequired}
            label={props.label}
            tooltipText={props.tooltipText}
        >
            <Spacer
                lastChildHasNoSpacing={true}
                spacing="small"
            >
                {props.checkboxOptions.map((checkbox, key) => {
                    return (
                        <Checkbox
                            checked={checkbox.checked}
                            key={key}
                            label={checkbox.label}
                            onChange={async (event) => await checkbox.onChange(event.target.checked)}
                        />
                    );
                })}
            </Spacer>
            <FormValidationMessage error={props.error} />
        </FormGroup>
    );
}

export interface ITextInput {
    label: 'Anders';
    onChange: (value: string | null) => void;
    value: string | null;
}

export interface ICheckbox {
    checked: boolean;
    label: Exclude<string, 'Anders'>;
    onChange: (value: boolean) => void;
}

export interface ICheckBoxGroupWithTextFieldProps {
    checkboxOptions: (ITextInput | ICheckbox)[];
    error?: string;
    hasErrors?: boolean;
    isRequired?: boolean;
    label: string;
    textFieldLabel?: string;
    tooltipText?: string;
}

/**
 * @deprecated CS-25100 use CheckboxGroupWithTextInputFormGroup instead. Remove if no longer used.
 */
export function CheckBoxGroupWithTextField(props: ICheckBoxGroupWithTextFieldProps) {
    return (
        <FormGroup
            hasErrors={props.hasErrors}
            isRequired={props.isRequired}
            label={props.label}
            tooltipText={props.tooltipText}
        >
            <Spacer
                lastChildHasNoSpacing={true}
                spacing="small"
            >
                <CheckboxesWithTextField
                    checkboxOptions={props.checkboxOptions}
                    error={props.error}
                    hasErrors={props.hasErrors}
                    textFieldLabel={props.textFieldLabel}
                />
            </Spacer>
        </FormGroup>
    );
}

/**
 * @deprecated CS-25100 use CheckBox with TextInput from DS instead. Remove if no longer used.
 */
export function CheckboxesWithTextField(
    props: Pick<ICheckBoxGroupWithTextFieldProps, 'checkboxOptions' | 'error' | 'hasErrors' | 'textFieldLabel'>
) {
    const [isTextInputChecked, setIsTextInputChecked] = useState(false);

    return (
        <>
            <Spacer
                lastChildHasNoSpacing={true}
                spacing="small"
            >
                {props.checkboxOptions.map((checkbox, key) => {
                    if (isTextInputType(checkbox)) {
                        return (
                            <div
                                key={key}
                                style={{ alignItems: 'flex-start', display: 'flex' }}
                            >
                                <Checkbox
                                    checked={isTextInputChecked || !!checkbox.value}
                                    onChange={async (e) => {
                                        setIsTextInputChecked(e.target.checked);
                                        if (!e.target.checked) {
                                            await checkbox.onChange(null);
                                        }
                                    }}
                                />
                                {props.textFieldLabel ? (
                                    <TextInputWithLabel
                                        label={props.textFieldLabel}
                                        onChange={(event) => {
                                            handleChangeTextInput(checkbox, event.target.value);
                                        }}
                                        value={checkbox.value || ''}
                                    />
                                ) : (
                                    <TextInput
                                        /* @TODO CS-20190 - the text input field misses validation by onBlur so that it is validated that the text is not larger than 255 characters */
                                        onChange={(event) => {
                                            handleChangeTextInput(checkbox, event.target.value);
                                        }}
                                        placeholder={props.textFieldLabel ? '' : 'Anders, namelijk...'}
                                        style={{ marginLeft: '12px' }}
                                        value={checkbox.value ?? ''}
                                    />
                                )}
                            </div>
                        );
                    } else {
                        return (
                            <Checkbox
                                checked={checkbox.checked}
                                key={key}
                                label={checkbox.label}
                                onChange={async (event) => await checkbox.onChange(event.target.checked)}
                                value={checkbox.label}
                            />
                        );
                    }
                })}
            </Spacer>
            <FormValidationMessage error={props.error} />
        </>
    );

    function handleChangeTextInput(checkBox: ITextInput, value: string) {
        checkBox.onChange(value || null);
        setIsTextInputChecked(!!value);
    }
}

function isTextInputType(checkbox: ICheckbox | ITextInput): checkbox is ITextInput {
    return 'value' in checkbox;
}
